import { Grid } from "@mui/material";
import { getContactUsRequest, updateContactUsRequest } from "api/contactUs";
import DrawerCM from "components/shared/Drawer";
import LoadingCM from "components/shared/Loading";
import ProgressBarCM from "components/shared/ProgressBar";
import StackCm from "components/shared/StackCm";
import TextFieldCm from "components/shared/TextField";
import Upload from "components/shared/Upload";
import Toast from "helper/toast";
import useHttp from "hooks/use-http";
import React, { useCallback, useState } from "react";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { StyledGlBtn } from "styles/globals";
import { validateImg } from "validations";

const INPUTS = [
  {
    id: "title",
    label: "عنوان",
  },
  {
    id: "phone_1",
    label: "شماره تماس 1",
  },
  {
    id: "phone_2",
    label: "شماره تماس 2",
  },
  {
    id: "telegram",
    label: "تلگرام",
  },
  {
    id: "whatsapp",
    label: "واتساپ",
  },
  {
    id: "address",
    label: "آدرس",
  },
  {
    id: "tel_link",
    label: "کانال تلگرام",
  },
  {
    id: "insta_link",
    label: "پیج اینستاگرام",
  },
  {
    id: "linkedin",
    label: "لینکدین",
  },
  {
    id: "alt",
    label: "متن جایگزین (alt)",
  },
];

export default function ContactUs() {
  const [image, setImage] = useState({
    isWeb: false,
    url: null,
    isChanged: false,
  });

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const { request, loading, isUploading, setUploadProgress, uploadProgress } =
    useHttp(false);

  const handleChangeImage = (val) => {
    const isValid = validateImg(val);
    isValid && setImage({ url: val, isChanged: true, isWeb: false });
  };

  const onSubmit = async (data) => {
    const res = await request({
      url: () =>
        updateContactUsRequest(
          {
            ...data,
            image: image.isWeb ? null : image.url,
          },
          (progress) => setUploadProgress(progress)
        ),
      isFile: true,
    });

    if (res) {
      Toast({ type: "success" });
      reset();
      getContactUs();
    }
  };

  const getContactUs = useCallback(async () => {
    const res = await request({
      url: getContactUsRequest,
    });
    if (res) {
      reset({
        title: res?.title || "",
        alt: res?.image?.alt || "",
        address: res?.address || "",
        phone_1: res?.phone_1 || "",
        phone_2: res?.phone_2 || "",
        telegram: res?.telegram || "",
        whatsapp: res?.whatsapp || "",
        tel_link: res?.tel_link || "",
        linkedin: res?.linkedin || "",
        insta_link: res?.insta_link || "",
      });
      setImage({
        isChanged: res?.image || false,
        url: res?.image?.url || null,
        isWeb: Boolean(res?.image?.url),
      });
    }
  }, []);

  useEffect(() => {
    getContactUs();
  }, [getContactUs]);

  return (
    <DrawerCM title="تماس باما">
      {isUploading ? (
        <ProgressBarCM value={uploadProgress} />
      ) : loading ? (
        <LoadingCM />
      ) : (
        <StackCm title="اطلاعات تماس باما">
          <Grid container>
            {INPUTS.map((input) => (
              <Grid key={input.id} item md={4} sm={6} xs={12} p={1.5}>
                <TextFieldCm {...input} register={register} errors={errors} />
              </Grid>
            ))}
            <Grid item md={8} xs={12} p={1.5}>
              <>
                {image.url && (
                  <Upload
                    isWeb={image.isWeb}
                    isLocal={!image.isWeb}
                    file={image.url}
                    refillable
                    type="add-image"
                    onChange={handleChangeImage}
                    width={"100%"}
                    height={"100%"}
                    objectFit="contain"
                  />
                )}
              </>
            </Grid>
            <StyledGlBtn onClick={handleSubmit(onSubmit)} />
          </Grid>
        </StackCm>
      )}
    </DrawerCM>
  );
}
